import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const SignatureTankBlack = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.tops.SignatureTankBlack.itemName}
      name={AW23.tops.SignatureTankBlack.itemName}
      price={AW23.tops.SignatureTankBlack.itemPrice}
      fabric={AW23.tops.SignatureTankBlack.itemFabric}
      src={AW23.tops.SignatureTankBlack.sizeChart}
      divId={AW23.tops.SignatureTankBlack.shopifyDivId}
      mainId={AW23.tops.SignatureTankBlack.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.tops.SignatureTankBlack.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.tops.SignatureTankBlack.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default SignatureTankBlack;
